export function getMonthNames(
  locale = "en",
  format: "long" | "short" | "narrow" = "long",
) {
  const formatter = new Intl.DateTimeFormat(locale, {
    month: format,
    timeZone: "UTC",
  });
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
    const mm = month < 10 ? `0${month}` : month;
    return new Date(`1984-${mm}-01T00:00:00+00:00`);
  });
  return months.map((date) => formatter.format(date));
}

export function getLocalizedDate(
  date: Date,
  locale = "en",
  options?: Intl.DateTimeFormatOptions,
) {
  return new Intl.DateTimeFormat(locale, options).format(date);
}

export function formatToYYYYMMDD(date: Date) {
  const yyyy = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
  const mm = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
  const dd = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);

  return `${yyyy}-${mm}-${dd}`;
}
